"use strict";
import ToggleMenu from './component/layout/ToggleMenu';
import { SystemErrorPage } from './component/errors/SystemErrorPage';
import { loader, loginLoader } from './loader';
import { history } from 'constants/router';
import { isDev } from './utils/env';
import { profilesAuthErrorRoute } from './modules/2bap/external/2bapProfiles/routes';
// import Playground from './views/Playground/Playground';

var AppError = require('utils').AppError;
var RouterRedirect = require('utils').RouterRedirect;
var Router = ReactRouter.Router;

var Logout = require('./views/logout/logoutPage');
var Security = require('./views/security/securityPage');

var ModulePath = require('./constants/modulePath');
var RoutePath = require('./constants/routePath');

var ModuleStore = require('store/moduleStore');

var errorApp = require('./component/errors/errorApp');
var NotFound = require('./views/notFound/notFoundPage');
var AccessDenied = require('./component/errors/accessDeniedPage');
var NoAvailableModulesPage = require('./component/errors/noAvailableModulesPage');

var routerUtility = require('./utils/routerUtility');
var getUrls = require('getUrls');
var menuActions = require('action/menuAction');

history.listenBefore(ToggleMenu.closeIfMinified);

window.addEventListener('popstate', () => {
  window.setTimeout(() => { history.transitionTo(history.getCurrentLocation()); });
});

var rootRoute = {
  childRoutes: [{
    path: '/',

    getIndexRoute(partialNextState, callback) {
      var error = routerUtility.getAccessError();
      if (error) {
        callback(error);
      } else {
        var currentModule = ModuleStore.getCurrentModule();
        callback(new RouterRedirect(ModulePath.getModulePath(currentModule)));
      }
    },

    getComponent(nextState, callback) {
      loader(nextState, callback);
    },

    getChildRoutes(partialNextState, callback) {
      var routesList = [
        {
          path: RoutePath.ROUTE_LOGIN,
          getComponent(nextState) { return loginLoader(nextState); }
        },
        {
          path: RoutePath.ROUTE_SECURITY,
          component: Security
        },
        {
          path: RoutePath.ROUTE_LOGOUT,
          component: Logout
        },
        {
          path: RoutePath.ROUTE_ERROR,
          component: errorApp,
          childRoutes: [
            {
              path: RoutePath.ROUTE_ACCESS_DENIED,
              component: AccessDenied,
            },
            {
              path: RoutePath.ROUTE_NO_AVAILABLE_MODULES,
              component: NoAvailableModulesPage,
            },
            {
              path: RoutePath.ROUTE_LOGOUT,
              component: require('./views/logout/logoutPage')
            }
          ]
        },
        {
          path: RoutePath.ROUTE_SYSTEM_ERROR,
          component: SystemErrorPage,
        },
        require('./modules/ra').routes,
        require('./modules/inspectionCoach').routes,
        require('./modules/inspectionCentre').routes,
        require('./modules/2bap/2bap').routes,
        require('./modules/2bap/external/2bapReports').routes,
        require('./modules/2bap/external/2bapProfiles/routes').default,
        require('./modules/2bap/external/2bapLearners/routes').default,
        require('./modules/custom/routes').default,
        {
          ...profilesAuthErrorRoute
        },
        require('./admin').routes,
        {
          //This child should be the last child routes!
          path: RoutePath.ROUTE_NOT_FOUND,
          component: NotFound
        }
      ];

      /*if (isDev()) {
        routesList.unshift(
          {
            path: RoutePath.ROUTE_PLAYGROUND,
            component: Playground
          }
        )
      }*/

      callback(null, routesList);
    }
  }
  ]
};


function onErrorRedirect(message) {
  if (message instanceof RouterRedirect) {
    this.router.replace(message.url);
  } else {
    switch (message.errorCode) {
      case AppError.CODE_ACCESS_DENIDED:
        this.router.replace(getUrls.getAccessDenied());
        break;
      case AppError.CODE_NO_AVAILABLE_MODULES:
        menuActions.cleanMenu();
        this.router.replace(getUrls.getNoAvailableModule());
        break;
      case AppError.CODE_UNAUTHORIZED:
        this.router.replace(RoutePath.ROUTE_LOGIN +
          routerUtility.getPathQuery(document.location.pathname));
        break;
    }
  }
}

var route = (
  <Router history={history}
          routes={rootRoute}
          onError={onErrorRedirect}
  />);

module.exports = route;
